import {
    SponsorItem as SchemaSponsorItem,
    SponsorItemClass as SchemaSponsorItemClass,
    SponsorItemType as SchemaSponsorItemType,
    SponsorPurchase as SchemaSponsorPurchase
} from '@vote4dance/judging-schema';
import { CompetitionId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type SponsorItem = SchemaSponsorItem & {
    sponsor_item_quantity_remaining?: number;
    sponsor_item_sold_out?: number;
};
export type SponsorItemClass = SchemaSponsorItemClass;
export type SponsorPurchase = SchemaSponsorPurchase;
export type SponsorItemType = SchemaSponsorItemType;
export type SponsorCurrency = 'sek' | 'eur' | 'usd' | 'nok';
export type SponsorItemTypeInput = SponsorItemType | 'tier' | 'class';

export type PublicSponsorPurchase = Pick<SponsorPurchase,
    'sponsor_purchase_id'
    | 'sponsor_item_id'
    | 'competition_id'
    | 'sponsor_purchase_company_name'
    | 'sponsor_purchase_company_link'
    | 'sponsor_purchase_company_image_id'
    | 'sponsor_purchase_contact_email'
    | 'claimed_at'
>
& Pick<SponsorItem,
    'sponsor_item_active'
    | 'sponsor_item_title'
    | 'sponsor_item_placements'
>;

export function SponsorItemsSource(competition_id: CompetitionId) {
    return new StreamSource<SponsorItem[]>(`/sponsor-items/${competition_id}`);
}

export function SponsorItemClassesSource(competition_id: CompetitionId) {
    return new StreamSource<SponsorItemClass[]>(`/sponsor-item-classes/${competition_id}`);
}

export function SponsorPurchasesSource(competition_id: CompetitionId) {
    return new StreamSource<SponsorPurchase[]>(`/sponsor-purchases/${competition_id}`);
}

export function SponsorClaimSource(claim_token: string) {
    return new StreamSource<PublicSponsorPurchase>(`/sponsor-claim/${claim_token}`);
}
